import ConsultationStep from './pages/consultation/ConsultationStep';
function App() {
  return (
    <div className="App">
      <ConsultationStep/>
    </div>
  );
}

export default App;
